export default class HeaderSlider {
    static init(): void {
        this.handleSlider();
        this.checkScrolled();
        this.handleScroll();
    }

    static handleSlider(): void {
        const carousel = document.querySelector('.header-slider');
        const itemList = carousel?.querySelector('.header-slider__items');
        const items = carousel?.querySelectorAll('.header-slider__item') as NodeListOf<HTMLElement>
        const next = carousel?.querySelector('.header-slider__arrow--right');
        const prev = carousel?.querySelector('.header-slider__arrow--left');

        if (items && prev && next) {
            prev.addEventListener('click', () => {
                if (prev.classList.contains('header-slider__arrow--hidden')) return;
                this.handlePrev(items);
                next?.classList.add('header-slider__arrow--hidden');
                prev?.classList.add('header-slider__arrow--hidden');

                const active = document.querySelector('.header-slider__item--active');
                const selected = active?.previousElementSibling as HTMLElement;
                this.selectSlide(selected);

                setTimeout(() => {
                    this.checkScrolled();
                }, 300);
            });
            next.addEventListener('click', () => {
                if (next.classList.contains('header-slider__arrow--hidden')) return;
                this.handleNext(items);
                next?.classList.add('header-slider__arrow--hidden');
                prev?.classList.add('header-slider__arrow--hidden');

                const active = document.querySelector('.header-slider__item--active');
                const selected = active?.nextElementSibling as HTMLElement;
                this.selectSlide(selected);

                setTimeout(() => {
                    this.checkScrolled();
                }, 600);
            });

            items.forEach((item: HTMLElement) => {
                item.addEventListener('click', () => {
                    if (!item.classList.contains('header-slider__item--active') && !itemList?.classList.contains('header-slider__items--dragging')) {
                        this.selectSlide(item);
                        this.checkScrolled();
                    }
                });
            });
        }
    }

    static handleNext(items: NodeListOf<Element>): void {
        const carousel = document.querySelector('.header-slider__items') as HTMLElement;
        const itemWidth = items[0].clientWidth;
        const active = document.querySelector('.header-slider__item--active') as HTMLElement;

        const carouselWidth = carousel?.clientWidth as number;
        const activePosition = active.getBoundingClientRect();
        const activeRight = activePosition.right;
        const carouselPosition = carousel?.getBoundingClientRect();
        const carouselRight = carouselPosition?.right as number;
        const activeRightOnView = activeRight - carouselRight;
        const activeRightOnViewAbs = Math.abs(activeRightOnView);

        let move = carouselRight;
        if (carouselWidth >= 600) {
            move = itemWidth + 40;
        } else {
            const slider = document.querySelector('.header-slider') as HTMLElement;
            const titlePlace = slider.querySelector('.header-slider__active-title') as HTMLElement;
            window.scrollTo({
                top: titlePlace.offsetTop - 80,
                behavior: 'smooth',
            });
        }

        if (activeRightOnViewAbs < carouselWidth / 2) {
            carousel?.scrollBy({
                top: 0,
                left: move,
                behavior: 'smooth'
            });
        }
    }

    static handlePrev(items: NodeListOf<Element>): void {
        const carousel = document.querySelector('.header-slider__items') as HTMLElement;
        const itemWidth = items[0].clientWidth;
        const active = document.querySelector('.header-slider__item--active') as HTMLElement;

        const carouselWidth = carousel?.clientWidth as number;
        const activePosition = active.getBoundingClientRect();
        const activeLeft = activePosition.left;
        const carouselPosition = carousel?.getBoundingClientRect();
        const carouselLeft = carouselPosition?.left as number;
        const activeLeftOnView = activeLeft - carouselLeft;
        const activeLeftOnViewAbs = Math.abs(activeLeftOnView);

        let move = itemWidth + 22;
        if (carouselWidth >= 600) {
            move = itemWidth + 40;
        } else {
            const slider = document.querySelector('.header-slider') as HTMLElement;
            const titlePlace = slider.querySelector('.header-slider__active-title') as HTMLElement;
            window.scrollTo({
                top: titlePlace.offsetTop - 80,
                behavior: 'smooth',
            });
        }

        if (activeLeftOnViewAbs < carouselWidth / 2) {
            carousel?.scrollBy({
                top: 0,
                left: -move,
                behavior: 'smooth',
            });
        }
    }

    static checkScrolled(): void {
        const next = document.querySelector('.header-slider__arrow--right') as HTMLElement;
        const prev = document.querySelector('.header-slider__arrow--left') as HTMLElement;
        const active = document.querySelector('.header-slider__item--active') as HTMLElement;

        if (!active) return;

        if (active.previousElementSibling) {
            prev.classList.remove('header-slider__arrow--hidden');
        } else {
            prev.classList.add('header-slider__arrow--hidden');
        }

        if (active.nextElementSibling) {
            next.classList.remove('header-slider__arrow--hidden');
        } else {
            next.classList.add('header-slider__arrow--hidden');
        }
    }

    static selectSlide(selected: HTMLElement): void {
        const wrapper = document.querySelector('.header-slider__wrapper') as HTMLElement;
        const items = wrapper.querySelectorAll('.header-slider__item') as NodeListOf<HTMLElement>;
        items.forEach((item: HTMLElement) => {
            item.classList.remove('header-slider__item--active');
        });

        const activePlace = wrapper.querySelector('.header-slider__active') as HTMLElement;
        const numberPlace = activePlace.querySelector('.header-slider__active-number') as HTMLElement;
        const titlePlace = activePlace.querySelector('.header-slider__active-title') as HTMLElement;
        const descriptionPlace = activePlace.querySelector('.header-slider__active-description') as HTMLElement;
        const buttonPlace = activePlace.querySelector('.header-slider__active-button') as HTMLElement;
        const background = wrapper.querySelector('.header-slider__wrapper-bg--desktop') as HTMLImageElement;
        const backgroundMobile = wrapper.querySelector('.header-slider__wrapper-bg--mobile') as HTMLImageElement;
        const image = selected.querySelector('.header-slider__item-image') as HTMLImageElement;
        const bottomNumberPlace = wrapper.querySelector('.header-slider__bottom-number') as HTMLElement;
        const bottomBar = wrapper.querySelector('.header-slider__bottom-bar-active') as HTMLElement;

        const newBackground = document.createElement("img");
        const newBackgroundMobile = document.createElement("img");
        newBackground.classList.add('header-slider__wrapper-bg', 'header-slider__wrapper-bg--desktop');
        newBackground.classList.add('header-slider__wrapper-bg-new');
        newBackgroundMobile.classList.add('header-slider__wrapper-bg', 'header-slider__wrapper-bg--mobile');
        newBackgroundMobile.classList.add('header-slider__wrapper-bg-new');
        newBackground.src = selected.dataset.slideImage || image.src || background.src;
        newBackground.alt = selected.dataset.slideTitle || image.alt || background.alt;
        newBackgroundMobile.src = selected.dataset.slideMobileImage || image.src || background.src;
        newBackgroundMobile.alt = selected.dataset.slideTitle || image.alt || background.alt;
        background.insertAdjacentElement('beforebegin', newBackground);
        background.style.zIndex = '-4';
        backgroundMobile.insertAdjacentElement('beforebegin', newBackgroundMobile);
        backgroundMobile.style.zIndex = '-4';

        // set same position as original image
        const imagePosition = image.getBoundingClientRect();
        newBackground.style.top = (imagePosition.top + window.scrollY) + 'px';
        newBackground.style.left = imagePosition.left + 'px';
        newBackground.style.width = (imagePosition.width || window.innerWidth) + 'px';
        newBackground.style.height = imagePosition.height + 'px';
        newBackgroundMobile.style.top = (imagePosition.top + window.scrollY) + 'px';
        newBackgroundMobile.style.left = imagePosition.left + 'px';
        newBackgroundMobile.style.width = (imagePosition.width || window.innerWidth) + 'px';
        newBackgroundMobile.style.height = imagePosition.height + 'px';

        activePlace.classList.add('header-slider__active--hidden');
        selected.classList.add('header-slider__item--active');

        setTimeout(() => {
            newBackground.classList.toggle("header-slider__wrapper-bg-new");
            newBackground.removeAttribute("style");
            newBackgroundMobile.classList.toggle("header-slider__wrapper-bg-new");
            newBackgroundMobile.removeAttribute("style");
        }, 100);

        setTimeout(() => {
            numberPlace.innerHTML = selected.getAttribute('data-slide-number') as string;
            titlePlace.innerHTML = selected.getAttribute('data-slide-title') as string;
            descriptionPlace.innerHTML = selected.getAttribute('data-slide-description') as string;
            buttonPlace.innerHTML = selected.getAttribute('data-slide-button') as string;
            buttonPlace.setAttribute('href', selected.getAttribute('data-slide-button-link') as string);
            bottomNumberPlace.innerHTML = selected.getAttribute('data-slide-number') as string;
            bottomBar.style.width = Number(selected.getAttribute('data-slide-number')) / items.length * 100 + '%';

            activePlace.classList.remove('header-slider__active--hidden');
        }, 300)

        setTimeout(() => {
            background.remove();
            backgroundMobile.remove();
        }, 500);

        // scroll to selected item
        const carousel = document.querySelector('.header-slider__items');
        const carouselWidth = carousel?.clientWidth as number;
        const selectedPosition = selected.getBoundingClientRect();
        const selectedLeft = selectedPosition.left;
        const carouselPosition = carousel?.getBoundingClientRect();
        const carouselLeft = carouselPosition?.left as number;
        const selectedLeftOnView = selectedLeft - carouselLeft;
        const selectedLeftOnViewAbs = Math.abs(selectedLeftOnView);

        if (selectedLeftOnViewAbs > carouselWidth / 2 || selectedLeftOnViewAbs < carouselWidth / 2) {
            carousel?.scrollBy({
                top: 0,
                left: selectedLeftOnViewAbs - carouselWidth / 2,
                behavior: 'smooth'
            });
        }
    }

    static handleScroll(): void {
        const slider = document.querySelector('.header-slider__items') as HTMLElement;
        if (!slider) return;

        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;


        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('header-slider__items--dragging');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('header-slider__items--dragging');
        });
        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX);
            slider.scrollLeft = scrollLeft - walk;
            slider.classList.add('header-slider__items--dragging');
        });


    }
}
